import { GET_FEATURES } from "../../actionTypes";
const initial_state = { features: [] };

const publicOfferingUpdatedTab = {
  feature: "IPO Management",
  title: "IPO Management",
  label: "IPO Management",
  type: "sub",
  classname: "icon-money mr-3",
  path: null,
  badgeType: "primary",
  active: false,
  children: [
    { type: "link", title: "IPO Setup", label: "IPO Setup", path: "/ipo-offering-updated", route: "/ipo-offering-updated", crud: [true, true, true, true], active: false, children: [] },
    { type: "link", title: "Subscription Uploader", label: "Subscription Uploader", path: "/ipo-subscription-uploader-updated", route: "/ipo-subscription-uploader-updated", crud: [true, true, true, true], active: false, children: [] },
    { type: "link", title: "Subscriptions", label: "Subscriptions", path: "/ipo-subscriptions-updated", route: "/ipo-subscriptions-updated", crud: [true, true, true, true], active: false, children: [] },
    { type: "link", title: "Allotment Decision", label: "Allotment Decision", path: "/ipo-allotment-decision-updated", route: "/ipo-allotment-decision-updated", crud: [true, true, true, true], active: false, children: [] },
    { type: "link", title: "Broker Management", label: "Broker Management", path: "/ipo-broker-management", route: "/ipo-broker-management", crud: [true, true, true, true], active: false, children: [] },
    { type: "link", title: "Occupation Code Management", label: "Occupation Code Management", path: "/ipo-occupation-code-management", route: "/ipo-occupation-code-management", crud: [true, true, true, true], active: false, children: [] },
    { type: "link", title: "Reports", label: "Reports", path: "/ipo-reports-updated", route: "/ipo-reports-updated", crud: [true, true, true, true], active: false, children: [] },
  ],
};

const fbrAtlLink = {
  type: "link",
  title: "FBR ATL",
  label: "FBR ATL",
  path: "/fbr-atl",
  route: "/fbr-atl",
  crud: [true, true, true, true],
  active: false,
  children: [],
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case GET_FEATURES: {
      if (!Array.isArray(action.payload) || !action.payload[0]) return state;
      const mappedFeatures = action.payload[0].children
        // Public Offerings (legacy) is superseded by "IPO Management" below, hide it from the sidebar
        .filter((f) => f.feature !== "Public Offerings")
        .map((f) => {
          if (f.feature)
            f.children =
              f.children.length !== 0
                ? f.children
                    // ATL Management (old filer-flag uploader) was removed; roles saved earlier may still list it
                    .filter((j) => j.route !== "/atl-listing")
                    .map((j) => ({
                    ...j,
                    type: "link",
                    title: j.label,
                    path: j.route,
                  }))
                : [];
          return {
            ...f,
            title: f.feature === "Shareholder" ? "Shareholders" : f.feature,
            type: f.feature === "Dashboard" ? "link" : "sub",
            classname: f.icon,
            path: f.route,
            badgeType: "primary",
            active: false,
          };
        });
      // FBR ATL lives under Corporate Actions. Roles saved before this page
      // existed don't have it in their stored feature tree, so make sure it
      // is always present.
      const corporateActions = mappedFeatures.find((f) => f.feature === "Corporate Actions");
      if (corporateActions && !corporateActions.children.some((c) => c.path === fbrAtlLink.path)) {
        corporateActions.children = [...corporateActions.children, fbrAtlLink];
      }
      // IPO Management sits right under Reporting, above Management —
      // brokers get added/updated there and their reports pulled from the
      // same section, so it belongs above Management, not tacked on at the
      // very end.
      const reportingIndex = mappedFeatures.findIndex((f) => f.feature === "Reporting");
      const insertAt = reportingIndex === -1 ? mappedFeatures.length : reportingIndex + 1;
      const features = [...mappedFeatures];
      features.splice(insertAt, 0, publicOfferingUpdatedTab);
      return {
        ...state,
        features,
      };
    }
    default:
      return state;
  }
};
